/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Signal_RelayInputs */

const bn_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংকেত রিলে`)
};

const de_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalrelais`)
};

const el_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ρελέ σήματος`)
};

const en_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signal relay`)
};

const es_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relé de señal`)
};

const fr_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relais du signal`)
};

const hi_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिग्नल रिले`)
};

const hu_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelző relé`)
};

const id_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relai sinyal`)
};

const it_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relè di segnale`)
};

const ja_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信号リレー`)
};

const ko_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신호 릴레이`)
};

const nl_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaal relais`)
};

const pl_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekaźnik sygnału`)
};

const pt_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relé de sinal`)
};

const ru_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сигнальное реле`)
};

const sv_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalrelä`)
};

const tr_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinyal rölesi`)
};

const uk_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реле сигналу`)
};

const vi_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rơle tín hiệu`)
};

const zh_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信号继电器`)
};

const zh_hant_cipher_transition_signal_relay = /** @type {(inputs: Cipher_Transition_Signal_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訊號繼電器`)
};

/**
* | output |
* | --- |
* | "Signal relay" |
*
* @param {Cipher_Transition_Signal_RelayInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_signal_relay = /** @type {((inputs?: Cipher_Transition_Signal_RelayInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Signal_RelayInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_signal_relay(inputs)
	if (locale === "de") return de_cipher_transition_signal_relay(inputs)
	if (locale === "el") return el_cipher_transition_signal_relay(inputs)
	if (locale === "en") return en_cipher_transition_signal_relay(inputs)
	if (locale === "es") return es_cipher_transition_signal_relay(inputs)
	if (locale === "fr") return fr_cipher_transition_signal_relay(inputs)
	if (locale === "hi") return hi_cipher_transition_signal_relay(inputs)
	if (locale === "hu") return hu_cipher_transition_signal_relay(inputs)
	if (locale === "id") return id_cipher_transition_signal_relay(inputs)
	if (locale === "it") return it_cipher_transition_signal_relay(inputs)
	if (locale === "ja") return ja_cipher_transition_signal_relay(inputs)
	if (locale === "ko") return ko_cipher_transition_signal_relay(inputs)
	if (locale === "nl") return nl_cipher_transition_signal_relay(inputs)
	if (locale === "pl") return pl_cipher_transition_signal_relay(inputs)
	if (locale === "pt") return pt_cipher_transition_signal_relay(inputs)
	if (locale === "ru") return ru_cipher_transition_signal_relay(inputs)
	if (locale === "sv") return sv_cipher_transition_signal_relay(inputs)
	if (locale === "tr") return tr_cipher_transition_signal_relay(inputs)
	if (locale === "uk") return uk_cipher_transition_signal_relay(inputs)
	if (locale === "vi") return vi_cipher_transition_signal_relay(inputs)
	if (locale === "zh") return zh_cipher_transition_signal_relay(inputs)
	return zh_hant_cipher_transition_signal_relay(inputs)
});